export type DebouncedLine = string | { text: string; debounce: number };

export function consumeLine(
  line: DebouncedLine,
  state: { lastFiredAt: Map<string, number> },
  now: number = Date.now(),
): string | null {
  if (typeof line === "string") return line;
  const last = state.lastFiredAt.get(line.text) ?? 0;
  if (now - last < line.debounce) return null;
  state.lastFiredAt.set(line.text, now);
  return line.text;
}
